export function buildQueryParams<TypeParams>(
  params: TypeParams
): URLSearchParams {
  const searchParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(key, item));
    } else if (value !== undefined && value !== null) {
      searchParams.set(key, value.toString());
    }
  });

  return searchParams;
}

export function handleQueryString(
  type: 'append' | 'delete' | 'set',
  searchParams: URLSearchParams,
  name: string,
  value?: string
) {
  const params = new URLSearchParams(searchParams.toString());
  params[type](name, value);

  return params.toString();
}
